import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from "@material-ui/core";

import { useState } from "react";

export default function MeditocTableSimple(props) {
    const { data, columns, addRows } = props;

    const pager = [10, 50, 200, 500, 2000];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pager[0]);

    if (!columns) {
        return;
    }

    if (!data) {
        return;
    }

    //Cambiar de pagina
    const handleChangePage = (e, page) => {
        setPage(page);
    };

    //Cambiar las filas por pagina
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setPage(0);
    };

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {columns.map((column, i) => (
                            <TableCell key={i}>{column.title}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody style={{ whiteSpace: "nowrap" }}>
                    {data.length > 0 ? (
                        data.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((dataRow, i) => (
                            <TableRow key={i}>
                                {columns.map((column, j) => (
                                    <TableCell key={j}>{dataRow[column["field"]]}</TableCell>
                                ))}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columns.length} align="center">
                                <Typography>No se encontraron registros para mostrar</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                    {addRows}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            count={data.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={pager}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
